import { Link } from "react-router";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";
import { cn } from "@/lib/cn";

type Organization = { id: string; name: string; slug: string; types: string[] };

export type AdminUserRow = {
  id: string;
  name: string;
  email: string;
  image: string | null;
  phone: string | null;
  platformRole: "MEMBER" | "ADMIN";
  onboardingCompletedAt: Date | null;
  lastLoginAt: Date | null;
  createdAt: Date;
  memberships: { role: string; organization: Organization }[];
};

function fmt(d: Date | null) {
  if (!d) return "—";
  return format(new Date(d), "dd MMM HH:mm", { locale: ptBR });
}

export function UserRow({ user }: { user: AdminUserRow }) {
  const organization = user.memberships[0]?.organization;
  const onboarded = !!user.onboardingCompletedAt;
  const initial = (user.name || "?").charAt(0).toUpperCase();

  return (
    <Link
      to={`/usuarios/${user.id}`}
      className="grid grid-cols-[auto_1fr_1fr_auto_auto] items-center gap-4 border-b border-admin-100 px-4 py-3 transition-colors hover:bg-admin-50"
    >
      {user.image ? (
        <img src={user.image} alt="" className="h-9 w-9 rounded-full object-cover" />
      ) : (
        <div className="flex h-9 w-9 items-center justify-center rounded-full bg-admin-900 text-xs font-semibold text-white">
          {initial}
        </div>
      )}

      <div className="min-w-0">
        <p className="truncate text-sm font-medium text-admin-900">
          {user.name || "(sem nome)"}
        </p>
        <p className="truncate text-xs text-admin-700">{user.email}</p>
      </div>

      <div className="hidden min-w-0 md:block">
        {organization ? (
          <>
            <p className="truncate text-sm text-admin-900">{organization.name}</p>
            <p className="truncate text-xs text-admin-700">
              {user.memberships[0]?.role} • {organization.types.join(", ")}
            </p>
          </>
        ) : (
          <span className="text-xs italic text-admin-700/50">sem clinica</span>
        )}
      </div>

      <div className="flex flex-col items-end gap-1">
        {user.platformRole === "ADMIN" && (
          <span className="rounded-full bg-red-500 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-white">
            ADMIN
          </span>
        )}
        <span
          className={cn(
            "text-xs",
            onboarded ? "text-green-700" : "text-amber-700",
          )}
        >
          {onboarded ? "Onboarded" : "Pendente"}
        </span>
      </div>

      <div className="hidden text-right text-xs text-admin-700 lg:block">
        <p className="text-admin-700/50">Ultimo acesso</p>
        <p className="font-medium">{fmt(user.lastLoginAt)}</p>
      </div>
    </Link>
  );
}
